module.exports = __webpack_public_path__ + "img/17.c6eaeaa3.jpg";